export default __webpack_public_path__ + "files/a28a47b367a554f962d42bfbcb2688d0.mp3";